import React, { useContext, useEffect, useState } from 'react'
import { useQlikTicketApi } from '../api/qlikTicket/qlikTicket.api'
import { QlikUIContext } from '../QlikUIContext'
import i18n from '../i18n'
import { MuiThemeProvider, useTheme } from '@material-ui/core/styles'

export const QlikWrapper = ({ component }) => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false)

  const currentTheme = useTheme()

  const context = useContext(QlikUIContext)
  const apiQlikTicket = useQlikTicketApi()

  async function loadCapabilityApis(capabilityApisCSS) {
    document.head.appendChild(capabilityApisCSS)
    capabilityApisCSS.loaded = new Promise((resolve) => {
      capabilityApisCSS.onload = () => {
        resolve()
      }
    })

    await Promise.all([capabilityApisCSS.loaded])
  }

  useEffect(() => {
    async function load(linq) {
      const tck = await apiQlikTicket.GetQlikTicket(
        context.userName,
        context.qlikEnvironmentUrl
      )
      linq.href = `${
        (context.qlikSecure ? 'https://' : 'http://') +
        context.qlikEnvironmentUrl +
        (context.qlikPort ? `:${context.qlikPort}` : '') +
        context.qlikPrefix
      }content/default/redir.css?${tck}`
      await loadCapabilityApis(linq)
      setScriptsLoaded(true)
    }

    const linq = document.createElement('link')
    linq.type = 'text/css'
    linq.rel = 'stylesheet'

    load(linq)

    return () => {
      document.head.removeChild(linq)
    }
  }, [])

  return (
    <div>
      <MuiThemeProvider theme={currentTheme}>
        {scriptsLoaded && component}
      </MuiThemeProvider>
    </div>
  )
}
